module.exports = __webpack_public_path__ + "static/img/driver-1.2fe1d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/driver-1.png
// module id = /grK
// module chunks = 0